import { formReducer } from './state/forms/reducer';
import { routerReducer } from 'react-router-redux';
import SignalRReducer from './api/SignalR/state/reducer';
import BasicSetupReducer from './components/basicsetup/state/reducer';
import UserSetupReducer from './pages/usersetup/state/reducer';
import ImportSiteReducer from './pages/importsite/state/reducer';
import SiteSetupReducer from './pages/sitesetup/state/reducer';
import LicenseReducer from './pages/license/state/reducer';
import AssignLicenseReducer from './pages/assignlicense/state/reducer';
import ImportStudentReducer from './pages/importstudents/state/reducer';
import SecurityReducer from './common/Security/state/reducer';
import ImportLogReducer from './pages/importlog/state/reducer';
import IncomeBracketReducer from './pages/incomebracket/state/reducer';
import TeacherRolesReducer from './pages/teacherrolls/state/reducer';
import TransactionHistoryReducer from './pages/transactionhistory/state/reducer';
import BillingAccountReducer from './pages/billingaccount/state/reducer';
import StudentAllergiesReducer from './pages/studentallergies/state/reducer';
import SpecialMessageReducer from './pages/specialmessage/state/reducer';
import GlobalUIReducer from './common/UI/state/reducer';
import AccountSetupReducer from './pages/accountsetup/state/reducer';
import CommonReducer from './state/reducer';
import ProhibitedItemsReducer from './pages/prohibiteditems/state/reducer';
import ManageApplicationReducer from './pages/manageapplication/state/reducer';
import ControlInformationReducer from './pages/controlinformation/state/reducer';
import CreditCardPaymentReducer from './pages/creditcardpayment/state/reducer';
import UserRoleAccessReducer from './pages/userroleaccess/state/reducer';
import SchoolCalendarReducer from './pages/schoolcalendar/state/reducer';
import VerificationConfigurationReducer from './pages/verificationconfiguration/state/reducer';
import LanguageSetupReducer from './pages/languagesetup/state/reducer';
import MBEReportReducer from './pages/mbereport/state/reducer';
import ItemSummaryReducer from './pages/itemsummary/state/reducer';
import StudentNotesModalReducer from './common/Components/StudentNoteModal/state/reducer';
import HomeReducer from './pages/home/state/reducer';
import DCImportReducer from './pages/dcimport/state/reducer';
import ImportResultReducer from './pages/importresult/state/reducer';
import ReviewIncomingApplicationsReducer from './pages/reviewincomingapplications/state/reducer';
import ReimbursementRatesReducer from './pages/reimbursementrates/state/reducer';
import LetterSetupReducer from './pages/lettersetup/state/reducer';
import DemographicsReportReducer from './pages/demographics/state/reducer';
import CaseTypeReportReducer from './pages/casetype/state/reducer';
import UnclosedDatesReducer from './pages/uncloseddates/state/reducer';
import ExtendedBenefitsReducer from './pages/extendedbenefits/state/reducer';
import ChecksSummaryReportReducer from './pages/checkssummaryreport/state/reducer';
import ParticipationReducer from './pages/participation/state/reducer';
import VerificationReportReducer from './pages/verificationreport/state/reducer';
import ReimbursementReducer from './pages/reimbursement/state/reducer';
import VerificationSelectionReducer from './pages/verificationselection/state/reducer';
import NutritionStandardsReportReducer from './pages/nutritionstandardsreport/state/reducer';
import ReceiptsAndCollectionsReportReducer from './pages/receiptsandcollections/state/reducer';
import VerificationCloseReducer from './pages/verificationclose/state/reducer';
import ViewApplicationDistributionReducer from './pages/viewapplicationdistribution/state/reducer';
import RevenueSummaryReportReducer from './pages/revenuesummaryreport/state/reducer';
import AccuclaimEditReducer from './pages/accuclaimedit/state/reducer';
import ChargesAndPrepaymentsReportReducer from './pages/chargesandprepaymentsreport/state/reducer';
import PointOfSaleReducer from './pages/pointofsale/reducer';
import CEPFundsDueReportReducer from './pages/cepfundsdue/state/reducer';
import LetterHistoryReportReducer from './pages/letterhistoryreport/state/reducer';
import SelectionLettersReducer from './pages/selectionletters/state/reducer';
import StatusChangeReducer from './pages/statuschange/state/reducer';
import UserSettingsReducer from 'Common/UserSettings/state/reducer';
import MasterRosterReducer from './pages/masterroster/state/reducer';
import UnappliedStudentsReportReducer from './pages/unappliedstudents/state/reducer';
import ResultsLettersReducer from './pages/resultsletters/state/reducer';
import InventoryBasicSetupReducer from './pages/inventory/inventorybasicsetup/state/reducer';
import MonthlyClaimFormReducer from './pages/monthlyclaimform/state/reducer';
import MBENotificationLettersReducer from './pages/mbenotification/state/reducer';
import NotificationsLetterReducer from './pages/notificationanddirectcertifiedletters/state/reducer';
import ServedItemSetupReducer from './pages/serveditemsetup/state/reducer';
import UserProfileReducer from './pages/userprofile/state/reducer';
import ProcessedDocumentsReducer from './pages/processeddocuments/state/reducer';
import IdCardsReducer from './pages/idcards/state/reducer';
import VendorSetupReducer from './pages/inventory/vendorsetup/state/reducer';
import TaxGroupSetupReducer from './pages/inventory/taxgroupsetup/state/reducer';
import ItemMaintenanceReducer from './pages/inventory/itemmaintenance/state/reducer';
import MealSummaryReducer from './pages/mealsummary/state/reducer';
import DailyDepositReducer from './pages/dailydeposit/state/reducer';
import LettersReducer from './pages/letters/state/reducer';
import ModifyDailyDepositReducer from './pages/modifydailydeposits/state/reducer';
import ServedItemAccessSetupReducer from './pages/serveditemaccesssetup/state/reducer';
import CEPSetupReducer from './pages/cepsetup/state/reducer';
import UncloseDayReducer from './pages/uncloseday/state/reducer';
import ManageOrderItemReducer from './pages/inventory/manageprocessorder/state/reducer';
import CEPBulkProcessingReducer from './pages/cepbulkprocessing/state/reducer';
import NotificationDialogReducer from 'Components/dialogs/state/reducer';
import LoginReducer from './pages/login/state/reducer';
import RosterCurrentBalanceReducer from './pages/rostercurrentbalance/state/reducer';
import TransferOrderReducer from './pages/inventory/transaction/transfer/state/reducers';
import ManageMenuReducer from './pages/managemenu/state/reducer';
import UpdateCEPCountsReducer from './pages/updatecepcounts/state/reducer';
import RecipeSearchReducer from 'Common/Components/RecipeSearch/state/reducer';
import UtilitiesReducer from './pages/utilities/state/reducer';
import UsageReducer from './pages/inventory/transaction/usage/state/reducers';
import PhysicalReducer from './pages/inventory/transaction/physical/state/reducers';
import AdjustmentReducer from './pages/inventory/transaction/adjustment/state/reducers';
import NewYorkSirsExportReducer from './pages/newyorksirsexport/state/reducer';
import SalesAnalysisReportReducer from './pages/salesanalysis/state/reducer';
import AccessPromptReducer from 'Common/Components/AccessPrompt/state/reducer';
import TransactionSummaryReducer from './pages/inventory/transaction/transactionSummary/state/reducer';
import LassoSelectionReducer from 'Common/Components/LassoSelection/state/reducer';
import PowerSchoolIntegrationReducer from './pages/powerschoolintegration/state/reducer';
import PowerSchoolExportReducer from './pages/powerschoolintegration/powerschoolexport/state/reducer';
import GenericExportReducer from './pages/genericexport/state/reducer';
import GenericExportSetupReducer from './pages/genericexportsetup/state/reducer';
import ManageRecipeReducer from './pages/managerecipe/state/reducer';
import ReportsReducer from './pages/reports/inventory/state/reducers';
import CloseSchoolYearReducer from './pages/CloseSchoolYear/state/reducer';
import KitchenItemReducer from './pages/centralkitchen/kitchenitems/state/reducer';
import KitchenPrepWorksheetReducer from './pages/centralkitchen/kitchenprepworksheet/state/reducers';
import MealEquivalentReducer from './pages/mealequivalentsetup/state/reducer';
import ManageIngredientReducer from './pages/manageingredient/state/reducers';
import TruckRouteReducer from './pages/inventory/truckroutes/state/reducers';
import ImportIngredientReducer from './pages/importingredients/state/reducer';
import ManageProductionReducer from './pages/manageproduction/state/reducer';
import UniversalDataExportReducer from './pages/universaldataexport/state/reducer';
import FamilyMatchUtility from './pages/familymatchutility/state/reducer';
import Provision2Reducer from './pages/provision2/state/reducer';
import Provision2BaseRatesSetupReducer from './pages/provision2baseratessetup/state/reducer';
import ExportTotalsReducer from './pages/exporttotals/state/reducer';
import TruckRouteScheduleReducer from './pages/inventory/truckrouteschedule/state/reducers';
import RecipePreparationReducer from './pages/recipepreparation/state/reducer';
import NetworkFilteringReducer from './pages/networkfiltering/state/reducer';
import PurchaseOrderReducer from './pages/inventory/managepurchaseorder/state/reducer';
import VendorLinkIntegrationReducer from './pages/vendorlinkintegration/state/reducer';
import VendingReducer from './pages/vendingsetup/state/reducer';
import SchoolSiteOrderReducer from './pages/schoolsiteorder/state/reducer';
import SimpleAverageReportReducer from './pages/simpleaverage/state/reducer';
import FoodBasedAnalysisReducer from './pages/reports/menus/foodbasedanalysisreport/state/reducer';
import RecipeListingReducer from './pages/recipelisting/state/reducer';
import DefaultLaborHoursReducer from './pages/defaultlaborhours/state/reducer';
import AeriesIntegrationReducer from './pages/aeriesintergration/state/reducer';
import SelectForVerificationReducer from './pages/selectedforverification/state/reducer';
import ProductionReportSetupReducer from './pages/productionreportsetup/state/reducer';

const reducers = {
  form: formReducer,
  SignalRState: SignalRReducer,
  CommonState: CommonReducer,
  GlobalUIState: GlobalUIReducer,
  BasicSetupState: BasicSetupReducer,
  UserSetupState: UserSetupReducer,
  ImportSiteState: ImportSiteReducer,
  SiteSetupState: SiteSetupReducer,
  LicenseState: LicenseReducer,
  AssignLicenseState: AssignLicenseReducer,
  routing: routerReducer,
  ImportStudentState: ImportStudentReducer,
  SecurityState: SecurityReducer,
  ImportLogState: ImportLogReducer,
  IncomeBracketState: IncomeBracketReducer,
  TeacherRollsState: TeacherRolesReducer,
  TransactionHistoryState: TransactionHistoryReducer,
  BillingAccountState: BillingAccountReducer,
  StudentAllergiesState: StudentAllergiesReducer,
  SpecialMessageState: SpecialMessageReducer,
  AccountSetupState: AccountSetupReducer,
  ProhibitedItemsState: ProhibitedItemsReducer,
  ManageApplicationState: ManageApplicationReducer,
  SelectForVerificationState: SelectForVerificationReducer,
  ControlInformationState: ControlInformationReducer,
  CreditCardPaymentState: CreditCardPaymentReducer,
  UserRoleAccessState: UserRoleAccessReducer,
  SchoolCalendarState: SchoolCalendarReducer,
  VerificationConfigurationState: VerificationConfigurationReducer,
  LanguageSetupState: LanguageSetupReducer,
  MBEReportState: MBEReportReducer,
  ItemSummaryState: ItemSummaryReducer,
  StudentNotesState: StudentNotesModalReducer,
  HomeState: HomeReducer,
  DCImportState: DCImportReducer,
  ImportResultState: ImportResultReducer,
  ReviewIncomingApplicationsState: ReviewIncomingApplicationsReducer,
  ReimbursementRatesState: ReimbursementRatesReducer,
  LetterSetupState: LetterSetupReducer,
  DemographicsReportState: DemographicsReportReducer,
  CaseTypeReportState: CaseTypeReportReducer,
  UnclosedDatesReportState: UnclosedDatesReducer,
  ExtendedBenefitsState: ExtendedBenefitsReducer,
  ChecksSummaryReportState: ChecksSummaryReportReducer,
  ParticipationReportState: ParticipationReducer,
  VerificationReportState: VerificationReportReducer,
  ReimbursementReportState: ReimbursementReducer,
  VerificationSelectionState: VerificationSelectionReducer,
  ReceiptsAndCollectionsReportState: ReceiptsAndCollectionsReportReducer,
  VerificationCloseState: VerificationCloseReducer,
  ViewApplicationDistributionState: ViewApplicationDistributionReducer,
  RevenueSummaryReportState: RevenueSummaryReportReducer,
  AccuclaimEditState: AccuclaimEditReducer,
  ChargesAndPrepaymentsReportState: ChargesAndPrepaymentsReportReducer,
  CEPFundsDueReportState: CEPFundsDueReportReducer,
  SelectionLettersState: SelectionLettersReducer,
  PointOfSaleState: PointOfSaleReducer,
  LetterHistoryReportState: LetterHistoryReportReducer,
  StatusChangeState: StatusChangeReducer,
  UserSettingsState: UserSettingsReducer,
  MasterRosterState: MasterRosterReducer,
  UnappliedStudentsReportState: UnappliedStudentsReportReducer,
  ResultsLettersState: ResultsLettersReducer,
  MonthlyClaimFormState: MonthlyClaimFormReducer,
  MBENotificationLettersState: MBENotificationLettersReducer,
  NotificationAndDirectCertifiedLettersState: NotificationsLetterReducer,
  ServedItemSetupState: ServedItemSetupReducer,
  UserProfileState: UserProfileReducer,
  ProcessedDocumentsState: ProcessedDocumentsReducer,
  IdCardsState: IdCardsReducer,
  VendorSetupState: VendorSetupReducer,
  InventoryBasicSetupState: InventoryBasicSetupReducer,
  TaxGroupSetupState: TaxGroupSetupReducer,
  ItemMaintenanceState: ItemMaintenanceReducer,
  MealSummaryState: MealSummaryReducer,
  UncloseDayState: UncloseDayReducer,
  DailyDepositState: DailyDepositReducer,
  LettersState: LettersReducer,
  ModifyDailyDepositState: ModifyDailyDepositReducer,
  ServedItemAccessSetupState: ServedItemAccessSetupReducer,
  CEPSetupState: CEPSetupReducer,
  ManageOrderItemState: ManageOrderItemReducer,
  CEPBulkProcessingState: CEPBulkProcessingReducer,
  NotificationDialogState: NotificationDialogReducer,
  AccessPromptState: AccessPromptReducer,
  LoginState: LoginReducer,
  RosterCurrentBalanceState: RosterCurrentBalanceReducer,
  TransferOrderState: TransferOrderReducer,
  UpdateCEPCountsState: UpdateCEPCountsReducer,
  ManageMenuState: ManageMenuReducer,
  RecipeSearchState: RecipeSearchReducer,
  UtilitiesState: UtilitiesReducer,
  UsageState: UsageReducer,
  PhysicalState: PhysicalReducer,
  AdjustmentState: AdjustmentReducer,
  NewYorkSirsExportState: NewYorkSirsExportReducer,
  SalesAnalysisState: SalesAnalysisReportReducer,
  TransactionSummaryState: TransactionSummaryReducer,
  LassoSelectionState: LassoSelectionReducer,
  PowerSchoolIntegrationState: PowerSchoolIntegrationReducer,
  PowerSchoolExportState: PowerSchoolExportReducer,
  GenericExportState: GenericExportReducer,
  GenericExportSetupState: GenericExportSetupReducer,
  ManageRecipeState: ManageRecipeReducer,
  ReportsState: ReportsReducer,
  CloseSchoolYear: CloseSchoolYearReducer,
  KitchenItemState: KitchenItemReducer,
  KitchenPrepWorksheetState: KitchenPrepWorksheetReducer,
  MealEquivalentState: MealEquivalentReducer,
  ManageIngredientState: ManageIngredientReducer,
  TruckRouteState: TruckRouteReducer,
  ImportIngredientState: ImportIngredientReducer,
  ManageProductionState: ManageProductionReducer,
  UniversalDataExportState: UniversalDataExportReducer,
  FamilyMatchUtilityState: FamilyMatchUtility,
  Provision2: Provision2Reducer,
  Provision2BaseRatesSetupState: Provision2BaseRatesSetupReducer,
  ExportTotalsState: ExportTotalsReducer,
  TruckRouteScheduleState: TruckRouteScheduleReducer,
  RecipePreparationState: RecipePreparationReducer,
  NetworkFilteringState: NetworkFilteringReducer,
  PurchaseOrderState: PurchaseOrderReducer,
  VendorLinkIntegrationState: VendorLinkIntegrationReducer,
  VendingState: VendingReducer,
  SchoolSiteOrderState: SchoolSiteOrderReducer,
  SimpleAverageReportState: SimpleAverageReportReducer,
  FoodBasedAnalysisState: FoodBasedAnalysisReducer,
  RecipeListingState: RecipeListingReducer,
  DefaultLaborHoursState: DefaultLaborHoursReducer,
  AeriesIntegrationState: AeriesIntegrationReducer,
  ProductionReportState: ProductionReportSetupReducer,
  NutritionStandardsReportState:NutritionStandardsReportReducer
};

const orderedReducers = {};
Object.keys(reducers)
  .sort((a, b) => {
    const aLowered = a.toLowerCase();
    const bLowered = b.toLowerCase();
    if (aLowered === bLowered) return 0;
    return aLowered < bLowered ? -1 : 1;
  })
  .forEach((key) => {
    orderedReducers[key] = reducers[key];
  });

export default orderedReducers;



// WEBPACK FOOTER //
// ./src/reducers.js